import React, {FC} from "react"
import "./LoadingIndicator.scss";
import classNames from "classnames";

export const LoadingIndicator: FC<{ className?: string }> = ({className}) => {
    return (
        <div className={classNames("round-spin", className)}>
        </div>
    );
}
